// import React from "react";
// import { Box, Typography, Paper, Grid } from "@mui/material";
// import { motion } from "framer-motion";
// import {
//   FiPackage,
//   FiCheckCircle,
//   FiAlertTriangle,
//   FiXCircle
// } from "react-icons/fi";

// export default function StockSummary() {
//   // 🔹 Sample data from your response
//   const summary = {
//     totalProducts: 18,
//     healthyStockCount: 10,
//     nearLowStockCount: 0,
//     lowStockCount: 0,
//     outOfStockCount: 8
//   };

//   // 🔹 Summary card details
//   const stats = [
//     {
//       label: "Total Products",
//       value: summary.totalProducts,
//       icon: <FiPackage size={24} />,
//       color: "#1e3a8a",
//       bg: "linear-gradient(135deg, #e0e7ff, #c7d2fe)"
//     },
//     {
//       label: "Healthy Stock",
//       value: summary.healthyStockCount,
//       icon: <FiCheckCircle size={24} />,
//       color: "#16a34a",
//       bg: "linear-gradient(135deg, #dcfce7, #bbf7d0)"
//     },
//     {
//       label: "Near Low Stock",
//       value: summary.nearLowStockCount,
//       icon: <FiAlertTriangle size={24} />,
//       color: "#f59e0b",
//       bg: "linear-gradient(135deg, #fef9c3, #fde68a)"
//     },
//     {
//       label: "Out of Stock",
//       value: summary.outOfStockCount,
//       icon: <FiXCircle size={24} />,
//       color: "#dc2626",
//       bg: "linear-gradient(135deg, #fecaca, #fca5a5)"
//     }
//   ];

//   return (
//     <Box sx={{ mb: 4 }}>
//       <Typography
//         variant="h5"
//         sx={{
//           fontWeight: 700,
//           mb: 2,
//           color: "#111827",
//           fontFamily: "Mulish, sans-serif",
//           mt: 3
//         }}
//       >
//         Inventory Stock Summary
//       </Typography>

//       <Grid container spacing={2}>
//         {stats.map((item, index) =>
//           <Grid item xs={12} sm={6} md={3} key={index}>
//             <Paper
//               elevation={3}
//               sx={{
//                 p: 3,
//                 borderRadius: 4,
//                 background: item.bg,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "flex-start",
//                 justifyContent: "center",
//                 minHeight: 120,
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
//               }}
//             >
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1.2,
//                   mb: 1,
//                   color: item.color
//                 }}
//               >
//                 {item.icon}
//                 <Typography
//                   variant="body2"
//                   sx={{ fontWeight: 600, color: item.color }}
//                 >
//                   {item.label}
//                 </Typography>
//               </Box>

//               <Typography
//                 variant="h4"
//                 sx={{
//                   fontWeight: 800,
//                   color: "#111827",
//                   lineHeight: 1.2
//                 }}
//               >
//                 {item.value}
//               </Typography>
//             </Paper>
//           </Grid>
//         )}
//       </Grid>
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Grid, CircularProgress, Alert } from "@mui/material";
import {
  FiPackage,
  FiCheckCircle,
  FiAlertTriangle,
  FiXCircle
} from "react-icons/fi";
import { getData } from "../Webservice/Webservice";

export default function StockSummary() {
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStockSummary = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData("dashboard/stock-summary", null, token);

        if (data && data.success && data.summary) {
          setSummaryData(data);
        } else {
          throw new Error("Invalid stock summary response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load stock summary data");
      } finally {
        setLoading(false);
      }
    };

    fetchStockSummary();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: "#111827",
            fontFamily: "Mulish, sans-serif",
            mt: 3
          }}
        >
          Inventory Stock Summary
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  // Show error state
  if (error) {
    return (
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: "#111827",
            fontFamily: "Mulish, sans-serif",
            mt: 3
          }}
        >
          Inventory Stock Summary
        </Typography>
        <Alert severity="error">
          {error}
        </Alert>
      </Box>
    );
  }

  // Show summary when data is available
  if (!summaryData) {
    return null;
  }

  const { summary } = summaryData;

  // 🔹 Summary card details
  const stats = [
    {
      label: "Total Products",
      value: summary.totalProducts,
      icon: <FiPackage size={24} />,
      color: "#1e3a8a",
      bg: "linear-gradient(135deg, #e0e7ff, #c7d2fe)"
    },
    {
      label: "Healthy Stock",
      value: summary.healthyStockCount,
      icon: <FiCheckCircle size={24} />,
      color: "#16a34a",
      bg: "linear-gradient(135deg, #dcfce7, #bbf7d0)"
    },
    {
      label: "Near Low Stock",
      value: summary.nearLowStockCount,
      icon: <FiAlertTriangle size={24} />,
      color: "#f59e0b",
      bg: "linear-gradient(135deg, #fef9c3, #fde68a)"
    },
    {
      label: "Out of Stock",
      value: summary.outOfStockCount,
      icon: <FiXCircle size={24} />,
      color: "#dc2626",
      bg: "linear-gradient(135deg, #fecaca, #fca5a5)"
    }
  ];

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          mb: 2,
          color: "#111827",
          fontFamily: "Mulish, sans-serif",
          mt: 3
        }}
      >
        Inventory Stock Summary
      </Typography>

      <Grid container spacing={2}>
        {stats.map((item, index) =>
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 4,
                background: item.bg,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                minHeight: 120,
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.2,
                  mb: 1,
                  color: item.color
                }}
              >
                {item.icon}
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: item.color }}
                >
                  {item.label}
                </Typography>
              </Box>

              <Typography
                variant="h4"
                sx={{
                  fontWeight: 800,
                  color: "#111827",
                  lineHeight: 1.2
                }}
              >
                {item.value}
              </Typography>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
